module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-10.c257e45e.png";